"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const date_fns_1 = require("date-fns");
/**
 * This function is going to be loaded into the helpers for goT
 * @param date - either the ISO string or the date itself
 * @param date_format - the string format to return, read https://date-fns.org/docs/format for more details
 * @returns the formatted date if params are valid, otherwise 'Invalid Date'
 */
function formatDate(date, date_format) {
    // if the date is string, check if it is ISO or valid
    if (typeof date === 'string') {
        date = (0, date_fns_1.parseISO)(date);
    }
    if ((0, date_fns_1.isValid)(date)) {
        return (0, date_fns_1.format)(date, date_format);
    }
    else {
        return 'Invalid Date';
    }
}
exports.formatDate = formatDate;
